import React, { useState } from 'react';
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem
} from '@mui/material';
import HeightBox from '../../components/HeightBox';

const FormGenerator = (props) => {
    const { fields,formData,handleChange } = props;

 
  return (
    <form>
    <Grid container spacing={3}>
      <Grid item xs={6}>
        {fields.slice(0, Math.ceil(fields.length / 2)).map((field, index) => (
          <Grid item xs={12} key={index}>
                      <HeightBox height={10}/>

            {field.type === 'TextField' && (
              <TextField
                name={field.name}
                label={field.label}
                size='small'
                value={formData[field.name] || ''}
                onChange={handleChange}
                required={field.required}
                fullWidth={field.fullWidth}
              />
            )}
               {
            field.type === 'Select' && (
                <TextField
                  name={field.name}
                  label={field.label}
                  size='small'
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  required={field.required}
                  fullWidth={field.fullWidth}
                  select
                >
                  {field.options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
            )}
            {field.type === 'Checkbox' && (
              <FormControlLabel
                control={
                  <Checkbox
                    name={field.name}
                    checked={formData[field.name] || false}
                    onChange={handleChange}
                  />
                }
                label={field.label}
              />
            )}
          </Grid>
        ))}
      </Grid>
      <Grid item xs={6}>
        {fields.slice(Math.ceil(fields.length / 2)).map((field, index) => (
          <Grid item xs={12} key={index}>
                      <HeightBox height={10}/>

            {field.type === 'TextField' && (
              <TextField
                name={field.name}
                label={field.label}
                size='small'
                value={formData[field.name] || ''}
                onChange={handleChange}
                required={field.required}
                fullWidth={field.fullWidth}
              />
            )}
               {
            field.type === 'Select' && (
                <TextField
                  name={field.name}
                  label={field.label}
                  size='small'
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  required={field.required}
                  fullWidth={field.fullWidth}
                  select
                >
                  {field.options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
            )}
            {field.type === 'Checkbox' && (
              <FormControlLabel
                control={
                  <Checkbox
                    name={field.name}
                    checked={formData[field.name] || false}
                    onChange={handleChange}
                  />
                }
                label={field.label}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Grid>
  </form>
  
  );
};

export default FormGenerator;